import { Injectable } from '@angular/core';
import { Observable, Subject } from 'rxjs';
import { Dialog } from '../../models/model.interface';
import { actionComponentData, actions } from '../../shared.interface';

@Injectable({
  providedIn: 'root',
})
export class DialogShareService {
  dialog = new Subject<any>();
  openDialog = new Subject<actions>();

  constructor() {}
  sendMessage(message: Dialog) {
    this.dialog.next({ res: message });
  }

  clearMessages() {
    this.dialog.next(null);
  }

  allowOpenDialog(componentObject: actions) {
    this.openDialog.next(componentObject);
  }

  getMessage(): Observable<any> {
    return this.dialog.asObservable();
  }
}
